<template>
  <div class="edit content-430">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="top"
    >
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>分账规则名称
        </h1>
        <Input
          v-model="formValidate.configName"
          :maxlength="20"
          placeholder="输入分账规则名称"
          style="width: 500px"
        ></Input>
      </FormItem>
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>分账业务类型
        </h1>
        <CourseTypes
          ref="courseTypesRef"
          :type-ids="courseTypeIds"
          :disabled="configId && materialSingle"
          @on-change="onCourseTypesChange"
        ></CourseTypes>
        <Checkbox
          v-model="materialSingle"
          :disabled="!!configId"
          @on-change="onMaterialSingleChange"
        >材料费</Checkbox>
        <div style="padding-left: 32px">
          <Checkbox
            v-model="materialSingle"
            :disabled="!!configId"
            @on-change="onMaterialSingleChange"
          >材料费</Checkbox>
        </div>
      </FormItem>
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>监管平台、银行
        </h1>
        <Row style="margin-bottom: 16px">
          <span>监管平台：</span>
          <Select
            v-model="formValidate.divRuleAcctType"
            style="width: 200px; margin-right: 20px"
            :disabled="!!configId"
            @on-change="onBankSelectChange"
          >
            <Option
              v-for="item in bankList"
              :key="item.code"
              :value="item.code"
            >{{ item.text }}</Option>
          </Select>
          <span>监管银行：</span>
          <Select
            v-model="formValidate.bankType"
            style="width: 200px; margin-right: 20px"
            :disabled="!!configId"
            @on-change="onSubBankSelectChange"
          >
            <Option
              v-for="item in subBankList"
              :key="item.bankType"
              :value="item.bankType"
            >{{ item.name }}</Option>
          </Select>
          <span>支付类型（收单）</span>
          <Select
            v-model="formValidate.payType"
            style="width: 200px"
            :disabled="!!configId"
          >
            <Option
              v-for="item in payTypeList"
              :key="item.payType"
              :disabled="item.payType == 2 || item.payType == 6"
              :value="item.payType"
            >{{ item.name }}</Option>
          </Select>
        </Row>
        <div class="flex flexrow flexac" style="margin-bottom: 20px">
          <div v-if="isWechat">
            <span>微信商户名称：</span>
            <Input
              v-model="formValidate.wxMchName"
              placeholder="微信商户名称"
              style="width: 200px"
            ></Input>
          </div>
          <div v-if="isWechat" class="cItem">
            <span>微信商户ID：</span>
            <Input
              v-model="formValidate.wxMchId"
              placeholder="微信商户ID"
              style="width: 200px"
              @on-blur="getWxMchId"
            ></Input>
          </div>
        </div>
        <RemarkCard>
          <p>
            说明：（1）根据不同的入账主体，匹配不同的分账模式。花都工行只支持单方分账；平安银行支持多方分账。
          </p>
        </RemarkCard>
      </FormItem>

      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>分账模式
        </h1>
        <RadioGroup v-model="formValidate.divideMode">
          <!-- v-show  微信下线 不显示单方支付 -->
          <Radio
            v-for="item in divideModeList"
            v-show="!(isWechat && item.modeCode == 1)"
            :key="item.modeCode"
            :label="item.modeCode"
            :disabled="true"
          >{{ item.name }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="configId" label="" prop="name">
        <h1><span class="color-red" style="margin-right: 4px">*</span>状态</h1>
        <RadioGroup v-model="formValidate.isEnable">
          <Radio :label="1">开启</Radio>
          <Radio :label="0">关闭</Radio>
        </RadioGroup>
        <p style="color: #aaa">
          提示：状态开启，发布新商品后可关联此分账规则。关闭后不可关联，已关联商品仍按之前关联规则分账。
        </p>
      </FormItem>
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>分账规则设置
        </h1>
        <Radio v-model="single">按比例分账</Radio>
        <div class="table-wrap" style="padding: 16px 0">
          <Table :columns="tableColumns" :data="tableList" border>
            <template slot="acctName" slot-scope="{ row, index }">
              <Tag v-if="row.type == 4 && !row.acctNo" color="cyan">{{
                row.acctName
              }}</Tag>
              <span v-else>{{ row.acctName }}</span>
              <Button
                v-show="row.type == 2 || row.type == 4"
                type="primary"
                size="small"
                style="margin-left: 16px"
                @click="handleTableReplace(row, index)"
              >选择</Button>
            </template>
            <template slot="platServiceRate" slot-scope="{ row, index }">
              <span v-if="row.actionType == 1">{{ row.platServiceRate }}</span>
              <Input
                v-else
                v-model="tableList[index]['platServiceRate']"
                placeholder="平台佣金"
                style="width: 200px"
                @on-blur="onPlatServiceRateBlur(row, index)"
              ></Input>
              %
            </template>
            <template slot="proportion" slot-scope="{ row, index }">
              <span v-if="row.actionType == 1">{{ row.proportion }}</span>
              <Input
                v-else
                v-model="tableList[index]['proportion']"
                placeholder="分账基数"
                style="width: 200px"
                @on-blur="onProportionBlur(row, index)"
              ></Input>
              %
            </template>
            <template slot="accountType" slot-scope="{ row, index }">
              <div v-show="row.actionType == 1 || row.accountType == 0">
                {{ getAccountTypeName(row.accountType) }}
              </div>
              <div v-show="row.actionType != 1 && row.accountType != 0">
                <!-- <div v-show="row.accountType == 0">--</div> -->
                <!-- <div v-show="row.accountType != 0"> -->
                <Select
                  v-model="tableList[index]['accountType']"
                  placeholder="请选择结算方式"
                  :transfer="true"
                >
                  <Option
                    v-for="item in accountTypeList"
                    :key="item.value"
                    :value="item.value"
                    :disabled="item.value != tableList[index]['accountType']"
                  >{{ item.name }}</Option>
                </Select>
                <!-- </div> -->
              </div>
            </template>

            <template slot="action" slot-scope="{ row, index }">
              <Button
                v-show="
                  row.actionType == 1 &&
                    !([2, 3].includes(formValidate.divRuleAcctType) && index == 0)
                "
                type="primary"
                size="small"
                style="margin-right: 5px"
                @click="handleTableEdit(row, index)"
              >编辑</Button>
              <Button
                v-show="row.actionType == 1 && row.type == 2"
                type="error"
                size="small"
                style="margin-right: 5px"
                @click="handleTableDelete(row, index)"
              >删除</Button>
              <Button
                v-show="row.actionType == 2"
                size="small"
                style="margin-right: 5px"
                @click="handleTableCancel(row, index)"
              >取消</Button>
              <Button
                v-show="row.actionType == 2"
                type="primary"
                size="small"
                @click="handleTableSave(row, index)"
              >保存</Button>
            </template>
          </Table>
          <div
            v-show="formValidate.divRuleAcctType == 1 && tableList.length < 5"
            style="padding-top: 16px"
          >
            <Button icon="ios-add" @click="handleAdd">新增分账对象</Button>
          </div>
        </div>
        <RemarkCard>
          <h2>说明：</h2>
          <p>（1）课程提供方为课程的提供方（机构），支持多方分账。</p>
          <p>
            （2）修改规则不影响之前规则已关联的商品，之前的商品仍按原有的分账规则进行分账。
          </p>
        </RemarkCard>
      </FormItem>
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>是否即时解冻
        </h1>
        <RadioGroup v-model="formValidate.freezeFlag">
          <Radio label="0" :disabled="formValidate.freezeFlag != '0'">是</Radio>
          <Radio label="1" :disabled="formValidate.freezeFlag != '1'">否</Radio>
        </RadioGroup>
        <RemarkCard style="margin-top: 4px">
          <h3>提示：</h3>
          <p>
            即时解冻：是，资金将T+1后，变成商户的可提现余额；否，资金将等待平台发起结算后方可解冻！设置后不可更改！<span
              class="color-red"
            >请谨慎设置！</span>
          </p>
        </RemarkCard>
      </FormItem>
      <FormItem v-if="configId && info" label="" prop="name">
        <h1>分账规则关联商品数</h1>
        <p>
          规则已关联商品数<span style="margin-left: 8px; color: red">{{
            info.relateProdNum
          }}</span>
        </p>
      </FormItem>
      <FormItem label="" prop="name">
        <h1>
          <span class="color-red" style="margin-right: 4px">*</span>渠道手续费承担方
        </h1>
        <div style="margin-bottom: 12px">
          <p class="flex">
            <span>承担方： </span>
            <RadioGroup v-model="formValidate.wxRateRespParty">
              <Radio :label="1">平台方（佣金方/末尾分账方）</Radio>
              <Radio
                v-show="formValidate.divRuleAcctType == 2"
                :label="2"
              >课程机构方</Radio>
            </RadioGroup>
          </p>
          <p class="flex">
            <span>手续费比例：</span>
            <InputNumber
              v-model="formValidate.wxRate"
              placeholder="手续费率"
              style="width: 150px"
              :precision="2"
              :max="formValidate.divRuleAcctType == 3 ? 2.0 : 0.6"
              :min="0"
              :step="0.01"
            >
            </InputNumber>
            <span style="margin-left: 10px">%</span>
          </p>
        </div>
        <RemarkCard>
          <h2>说明</h2>
          <p>1.配置该分账规则下，渠道手续费计入对应的主体。</p>
        </RemarkCard>
      </FormItem>

      <FormItem label="" prop="name">
        <h1>备注</h1>
        <Input
          v-model="formValidate.remark"
          type="textarea"
          :rows="4"
          :maxlength="50"
          :show-word-limit="true"
          placeholder="备注内容"
          style="width: 700px"
        ></Input>
      </FormItem>
    </Form>
    <!-- <ChooseTarget></ChooseTarget> -->
    <ChooseOneOrgModal
      ref="chooseOneOrgModal"
      :divide-mode2="divideMode2"
      :bank-id="formValidate.bankId"
      :merchant-kind-ids="formValidate.divRuleAcctType == 1 ? [1, 3, 4] : []"
      @on-finish="onOrgFinish"
    >
    </ChooseOneOrgModal>
    <SmsCodeModal
      ref="smsCodeModal"
      :modal-title="`敏感操作提示`"
      :check-type="`UPDATE_DIV_CONFIG:${configId}`"
      @sendCode="hadnleSendCode"
    ></SmsCodeModal>

    <ChooseLineOrgModal
      ref="chooseLineOrgModal"
      :divide-mode2="divideMode2"
      :bank-id="formValidate.bankId"
      @on-finish="onOrgFinish"
    >
    </ChooseLineOrgModal>

    <div class="formbtnbox-430-bottom">
      <Button
        type="primary"
        :loading="isSaveing"
        :disabled="isSaveing"
        @click="checkAllForm()"
      >保存</Button>
      <Button @click="handleGoBack">取消</Button>
    </div>
    <Modal
      v-model="showTips"
      title="提示"
      ok-text="我已知晓上述说明！"
      @on-ok="ok"
    >
      <p>
        1、选择微信商户（线下）入账主体，资金将进入配置的指定商户，平台不进行账单实际结算打款。仅生成账单后用于核对和维护学生课时考勤结算状态。请配置前仔细核对！！
      </p>
      <p>2、请正确配置微信商户的手续费率</p>
      <p>3、对应账单生成的数据非实际打款数据，请以实际打款为准</p>
      <b>请确定您已知晓上述说明！</b>
      <div slot="footer" class="flex flexac flexjc">
        <Button type="primary" @click="ok">我已知晓上述说明！</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { oneColumns, twoColumns } from './assets/data/edit';
import orderCenterApi from '@/request/orderCenter/index.js';
import { mapMutations } from 'vuex';

export default {
  components: {
    RemarkCard: () =>
      import('@c/Base/RemarkCard.vue'),
    ChooseOneOrgModal: () =>
      import('./assets/components/ChooseOneOrgModal.vue'),
    SmsCodeModal: () =>
      import('./assets/components/SmsCodeModal.vue'),
    CourseTypes: () =>
      import('@c/Base/CourseTypes.vue'),
    ChooseLineOrgModal: () =>
      import('./assets/components/ChooseLineOrgModal.vue')
  },
  data() {
    return {
      bankList: [],
      single: true,
      materialSingle: false,
      configId: this.$route.query.configId,
      providerType: 1, //  1-校外机构 2-学校
      materialRadio: '1',

      formValidate: {
        configName: '',
        bankId: '-1',
        divideMode: '-1',
        remark: '',
        accountingType: '1',
        subConfigs: [],
        busiTypes: [],
        smsCode: '',
        isEnable: 1,
        wxMchName: '',
        wxMchId: '',
        wxRate: 0.6,
        customCycleBegin: '',
        customCycle: null,
        bankType: '',
        divRuleAcctType: -1,
        wxRateRespParty: 1, // 微信手续费率承担方（万分比） 1-平台 2-机构
        accountingNum: 1,
        freezeFlag: '0',
        payType: ''
      },
      showTips: false, //  弹框状态
      divideModeList: [{ name: '单方分账', modeCode: 1 }, { name: '多方分账', modeCode: 2 }], // 分账模式 列表
      accountTypeList: [{ name: '线上结算', value: 1 }, { name: '线下结算', value: 2 }],
      ruleValidate: {

      },
      // divideMode:1  单方分账; 2 多方分账
      tableList: [],
      // “单方分账” 表格数据结构用divideMode1，“多方分账” 表格数据结构用divideMode2
      divideMode1: [{
        platServiceRate: 18.00,
        proportion: 100.00,
        acctType: '比例分账',
        acctName: '课程提供方',
        accountType: 0,
        actionType: 1, // 1 : 显示，2:编辑
        type: '1' // 1 : 主体、 2: 机构 3 末位 4 可选择课程提供方，5 平台佣金
      },
      {
        platServiceRate: 18.00,
        proportion: 0,
        acctType: '比例分账',
        acctName: '平台佣金',
        accountType: 1,
        actionType: 1, // 1 : 显示，2:编辑
        type: '5' // 1 : 主体、 2: 机构 3 末位 4 可选择课程提供方，5 平台佣金
      }], // divideMode 1 的表单数据
      divideMode2: [{
        acctType: '比例分账',
        acctName: '课程提供方',
        proportion: 100,
        accountType: 0,
        actionType: 1, // 1 : 显示，2:编辑
        acctNo: '',
        type: '1' // 1 : 主体、 2: 机构 3 末位  4 可选择课程提供方
      }, {
        acctType: '末位分账',
        acctName: '末位分账',
        proportion: 0,
        accountType: 0,
        actionType: 1, // 1 : 显示，2:编辑
        type: '3' // 1 : 主体、 2: 机构 3 末位 5 平台佣金
      }], // divideMode 2 的表单数据
      tableEdit: false, //
      isSaveing: false,
      info: null,
      tempInfo: null,
      replaceIndex: -1,
      courseTypeIds: [],
      configdOrgList: [],
      accountingCustomCycleBegin: '', // 时间控件 value
      isWechat: false,
      bankIdList: [], // 存储BankId
      pageShow: false,
      payTypeEnum: [{
        payType: 1,
        code: 3,
        name: '微信支付'
      }, {
        payType: 9,
        code: 3,
        name: '微信服务商'
      }, {
        payType: 2,
        code: 1,
        name: '平安见证宝'
      }, {
        payType: 6,
        code: 2,
        name: '并笔支付'
      }, {
        payType: 7,
        code: 2,
        name: '单笔支付'
      }, {
        payType: 8,
        code: 1,
        name: '平安银行云收款'
      }]

    };
  },
  computed: {
    tableColumns() {
      return this.formValidate.divideMode == 1 ? oneColumns : twoColumns;
    },
    disabledDatePicker() {
      return !!this.accountingCustomCycleBegin;
    },
    subBankList() {
      const key = this.bankList.findIndex(item => { return item.code == this.formValidate.divRuleAcctType; });
      console.log(key, this.bankList[key]);
      return key != -1 ? this.bankList[key]['bankTypes'] : [];
    },
    payTypeList() {
      const list = [];
      console.log('subBankList', this.subBankList);
      if (this.subBankList && this.subBankList.length) {
        this.subBankList.forEach(item => {
          if (item.bankType == this.formValidate.bankType) {
            item.payType.forEach(item_1 => {
              const key = this.payTypeEnum.findIndex(item_2 => { return item_1 == item_2.payType; });
              if (key != -1) {
                list.push(this.payTypeEnum[key]);
              }
            });
          }
        });
      }
      console.log('list', list);
      return list;
      // payType 、name
    },
    wxRateDisabled() {
      return !!this.configId;
    }
  },
  watch: {
    'formValidate.divideMode': function(newValue) {
      console.log('formValidate.divideMode', newValue, this.divideMode1, this.formValidate.bankType);
      if (!this.configId) {
        this.formValidate.bankType = '';
      }
      if (newValue == 1) {
        this.tableList = this.divideMode1;
      } else {
        this.tableList = this.divideMode2;
      }
    },
    'formValidate.bankType': function(newVal) {
      if (newVal === 'ICBC_HD' || newVal === 'ICBC_ZS') {
      } else {
      }
    },
    'formValidate.divRuleAcctType': function(newVal) {
      // 1: 平安，2: 工行 3: 微信支付
      switch (Number(newVal)) {
        case 1:
          this.configId ? '' : this.formValidate.freezeFlag = '1';
          this.divideMode2[this.divideMode2.length - 1]['accountType'] = 1;
          break;
        case 2:
          this.configId ? '' : this.formValidate.freezeFlag = '0';
          break;
        case 3:
          this.configId ? '' : this.formValidate.freezeFlag = '0';
          this.divideMode2[this.divideMode2.length - 1]['accountType'] = 2;
          break;
      }
    }
  },
  beforeCreate() {
    console.log('edit beforeCreate');
  },
  beforeMount() {
    console.log('edit beforeMount');
  },
  created() {
    console.log('edit created');
    this.init();
  },
  mounted() {
    console.log('edit mounted');
  },
  destroyed() {
    console.log('edit destroyed');
  },
  beforeDestroy() {
    console.log('edit beforeDestroy');
  },
  methods: {
    ...mapMutations(['DELETE_CACHEROUTE']),
    // 输入框失焦
    handleInputNumberBlur() {
      if (this.formValidate.customCycle < 7) {
        this.formValidate.customCycle = 7;
      }
    },
    // 配置账期周期 结算起始时间 变化
    onDateChange(date) {
      this.formValidate.customCycleBegin = date;
    },
    // 输入框值变化
    handleInputNumberChange(num) {
    },
    async init() {
      await this.getFindBankList();
      if (this.configId) {
        this.getDivideConfigdDetail();
      }
    },
    // 根据银行获取分账模式
    async getFindBankModeList(bankId) {
      const res = await orderCenterApi.getAcctTypes();
      console.log('res', res);
      if (res.status == 200) {
        this.divideModeList = res.message;
        if (this.divideModeList.length) {
          this.formValidate.divideMode = this.divideModeList[0]['modeCode'];
        }
      }
    },
    async getDivideConfigdOrgList() {
      return new Promise(async(resolve, reject) => {
        const res = await orderCenterApi.getDivideConfigdOrgList({
          configId: this.configId
        });
        if (res.status == 200) {
          this.configdOrgList = res.message;
          if (res.message.length > 0) {
            this.divideMode2[0].acctName = res.message[0]['acctName'] || res.message[0]['orgName'];
            this.divideMode2[0].orgId = res.message[0]['orgId'];
            this.divideMode2[0].acctNo = res.message[0]['acctNo'];
            this.formValidate.accountingType = res.message[0]['accountingType'] + '';
            this.formValidate.customCycle = res.message[0]['accountingCustomCycle'];
            this.formValidate.customCycleBegin = res.message[0]['accountingCustomCycleBegin'] ? res.message[0]['accountingCustomCycleBegin'].split(' ')[0] : '';
            this.accountingCustomCycleBegin = res.message[0]['accountingCustomCycleBegin'];
          }
          resolve();
        }
      });
    },
    getWxMchId() {
      this.formValidate.wxMchId = this.formValidate.wxMchId.replace(/\s+/g, '');
    },
    // 分账基数 输入框失去焦点时触发
    onProportionBlur(row, index) {
      this.tableList[index]['proportion'] = Math.abs(this.tableList[index]['proportion']);
      if (!this.isDecimal(this.tableList[index]['proportion'])) {
        this.tableList[index]['proportion'] = Math.floor(this.tableList[index]['proportion'] * 100) / 100;
      }
    },
    onPlatServiceRateBlur(row, index) {
      if (!this.isDecimal(this.tableList[index]['platServiceRate'])) {
        this.tableList[index]['platServiceRate'] = Math.floor(Math.abs(this.tableList[index]['platServiceRate']) * 100) / 100;
      }
    },
    ok() {
      this.showTips = false;
    },
    // isInit 编辑进来就不显示提示了
    onBankSelectChange(code, isInit = false) {
      this.bankType = '';
      if (code != -1) {
        this.isWechat = false;
        const obj = this.bankList.find(function(i) {
          return i.code === code;
        });
        this.formValidate.divideMode = obj.divMode;
        // 微信线下
        if (code == 3) {
          this.isWechat = true;
          if (!isInit) {
            this.showTips = true;
          }
        }
        const bankIditem = this.bankIdList.find(function(i) {
          return i.acctPlatType == code;
        });

        this.formValidate.bankId = bankIditem ? bankIditem.bankId : null;
        if (!this.configId) {
          this.initDivideMode2();
        }
      } else {
        this.formValidate.divideMode = '-1';
        this.isWechat = false;
        this.formValidate.bankId = null;
      }

      this.setRate(code);
    },
    // 根据入账监管平台设置手续费默认值
    setRate(code) {
      this.formValidate.wxRateRespParty = 1;
      switch (Number(code)) {
        case 1:
          this.formValidate.wxRate = 0.60;
          break;
        case 2:
          this.formValidate.wxRate = 0.60;
          break;
        case 3:
          this.formValidate.wxRate = 0.60;
          break;
      }
    },
    onSubBankSelectChange(val) {
      // 如果是工银的
      console.log(val, '拿到的--534543', this.bankIdList, this.subBankList);
      if (+this.formValidate.divRuleAcctType === 2) {
        const item = this.subBankList.find(item => {
          return item.bankType === val;
        });
        item ? this.formValidate.bankId = item.bankId : '';
        this.divideMode1 = [{
          platServiceRate: 18.00,
          proportion: 100.00,
          acctType: '比例分账',
          acctName: '课程提供方',
          accountType: 0,
          actionType: 1, // 1 : 显示，2:编辑
          type: '1' // 1 : 主体、 2: 机构 3 末位 4 可选择课程提供方
        }, {
          platServiceRate: 18.00,
          proportion: 0,
          acctType: '比例分账',
          acctName: '平台佣金',
          accountType: 1,
          actionType: 1, // 1 : 显示，2:编辑
          type: '5' // 1 : 主体、 2: 机构 3 末位 4 可选择课程提供方，5 平台佣金
        }];
        this.tableList = Object.assign([], this.divideMode1);
      }
    },
    getFillBankType(info) {
      const bankKey = this.bankList.findIndex(item => { return item.code == info.inAccountType; });
      console.log(this.bankList[bankKey], 'this.bankList[bankKey]');
      if (bankKey != -1) {
        const key = this.bankList[bankKey].bankTypes.findIndex(item => { return item.bankId == info.bankId; });
        console.log('this.bankList[bankKey].bankTypes[key]', this.bankList[bankKey].bankTypes[key]);
        if (key != -1) {
          return this.bankList[bankKey].bankTypes[key]['bankType'];
        }
      }
      return null;
    },
    fillForm(info) {
      this.formValidate.configName = info.configName;
      this.formValidate.divRuleAcctType = info.inAccountType;
      this.formValidate.bankType = this.getFillBankType(info);
      this.formValidate.payType = info.payType;
      this.onBankSelectChange(info.inAccountType, true);
      this.formValidate.remark = info.remark;
      this.formValidate.isEnable = info.isEnable;
      this.courseTypeIds = info.busiTpyes;
      this.materialSingle = info.itemType == 2;
      this.formValidate.wxMchName = info.wxMchName;
      this.formValidate.wxMchId = info.wxMchId.replace(/\s+/g, '');
      this.formValidate.wxRateRespParty = info.wxRateRespParty;
      this.formValidate.freezeFlag = String(info.freezeFlag);
      this.formValidate.wxRate = info.wxRate && (parseFloat(info.wxRate / 100));
      if (this.formValidate.divideMode == 1) {
        this.divideMode1[0].proportion = info.proportion / 100;
        this.divideMode1[1].proportion = info.platServiceRate / 100;
      } else if (this.formValidate.divideMode == 2) {
        this.initDivideMode2();
        this.divideMode2[0].proportion = info.proportion / 100;
      }
      info.divideItemList && info.divideItemList.forEach(item => {
        //
        // // 1-普通清分方 2-平台（末位）清分方
        if (item.itemType == 1) {
          this.divideMode2.splice(this.divideMode2.length - 1, 0, {
            acctType: '比例分账',
            acctName: this.isWechat ? item.orgName : item.acctName,
            proportion: item.proportion / 100,
            actionType: 1, // 1 : 显示，2:编辑
            acctNo: item.acctNo,
            type: '2',
            orgId: item.orgId
          });
        } else if ((item.itemType == 2)) {
          this.divideMode2[this.divideMode2.length - 1].proportion = item.proportion / 100;
        }
      });
    },
    // 获取详情
    async getDivideConfigdDetail() {
      const res = await orderCenterApi.getDivideConfigdDetail({
        configId: this.configId
      });
      if (res.status == 200) {
        this.info = res.message;
        this.fillForm(res.message);
      }
    },
    //
    setAccountingNum() {
      this.materialRadio = this.configdOrgList[0].accountingNum > 0 ? '1' : '2';
      this.formValidate.accountingNum = this.configdOrgList[0].accountingNum < 1 ? 1 : this.configdOrgList[0].accountingNum;
    },
    // 获取银行列表
    async getFindBankList() {
      const bank = await orderCenterApi.getFindBankList();
      this.bankIdList = [...bank.message];
      const res = await orderCenterApi.getAcctTypes();
      if (res.status == 200) {
        this.bankList = [{
          code: '-1',
          text: '请选择'
        }, ...res.message];
      }
    },
    // 检查必填项
    checkForm() {
      console.log('this.formValidate', this.formValidate);
      const { configName, bankId, bankType, divideMode, remark, wxMchName, wxMchId, wxRate, payType } = this.formValidate;
      if (!configName) {
        this.$Message.warning('分账规则名称不可为空');
        return null;
      }
      if (!this.materialSingle && this.$refs.courseTypesRef.getResult().typeIds.length == 0) {
        this.$Message.warning('分账业务类型不可为空');
        return null;
      }
      if (bankId == -1) {
        this.$Message.warning('请选择监管平台');
        return null;
      }
      if (bankType == '') {
        this.$Message.warning('请选择监管银行');
        return null;
      }
      if (payType == '') {
        this.$Message.warning('请选择支付类型');
        return null;
      }
      if (this.formValidate.accountingType == 2 && (!this.formValidate.customCycle || !this.formValidate.customCycleBegin)) {
        this.$Message.warning(`请填写结算起始时间或冻结时间`);
        return null;
      }
      if (this.isWechat) {
        if (!wxMchName) {
          this.$Message.warning('请微信商户名称');
          return null;
        }
        if (!wxMchId) {
          this.$Message.warning('请输入微信商户ID');
          return null;
        }
      }
      if (wxRate === null || wxRate === '') {
        this.$Message.warning('请输入手续费率');
        return null;
      }
      if (this.formValidate.divRuleAcctType == 3) {
        if (wxRate && wxRate > 2.0) {
          this.$Message.warning('手续费率不能超过2.0%');
          return null;
        }
      } else {
        if (wxRate && wxRate > 0.6) {
          this.$Message.warning('手续费率不能超过0.6%');
          return null;
        }
      }

      if (divideMode == 1) {
        if (Number(this.tableList[1]['proportion']) > 100) {
          this.$Message.warning(`"平台佣金" 不能大于 100%  `);
          return null;
        }
        if (Number(this.tableList[1]['proportion']) < 0) {
          this.$Message.warning(`"平台佣金" 不能小于 0%  `);
          return null;
        }
      } else if (divideMode == 2) {
        const result = this.tableList.reduce((total, currentValue) => Number(total) + (Number(currentValue.proportion) * 100), 0) / 100;
        if (result != 100) {
          this.$Message.warning(`所有分账基数相加要等于100%`);
          return null;
        }
      }
      return true;
    },
    getParameterAccountNo() {
      return (this.formValidate.bankType == 'ICBC_HD' || this.formValidate.bankType == 'ICBC_ZS') ? this.divideMode1[0]['acctNo'] : this.divideMode2[0]['acctNo'];
    },
    // 获取提交参数
    getParameter() {
      if (!this.checkForm()) {
        return null;
      }
      const { configName, bankId, bankType, divideMode, remark, divRuleAcctType, wxRateRespParty, payType, freezeFlag } = this.formValidate;
      const parameter = {
        configName,
        divRuleAcctType,
        remark,
        bankType,
        payType,
        // 材料费 512
        busiTypes: this.materialSingle ? [0] : this.$refs.courseTypesRef.getResult().typeIds,
        itemType: this.materialSingle ? 2 : 1,
        wxRateRespParty,
        freezeFlag
      };
      const accountingNum = null;
      if (divideMode == 1) {
        parameter.proportion = Number(this.tableList[0]['proportion']) * 100;
        parameter.platServiceRate = Number(this.tableList[1]['proportion']) * 100;
        parameter.lastProportion = 0;
        parameter.lastDivideChannel = this.tableList[1]['accountType'];
      } else if (divideMode == 2) {
        const subConfigs = [];
        parameter.proportion = Number(this.tableList[0]['proportion']) * 100;
        parameter.platServiceRate = 0;
        parameter.lastDivideChannel = this.tableList[this.tableList.length - 1]['accountType'];

        parameter.lastProportion = divRuleAcctType == 1 ? Number(this.tableList[this.tableList.length - 1]['proportion']) * 100 : 0;
        this.divideMode2.forEach((item, index) => {
          if (index != 0 && index != this.divideMode2.length - 1) {
            const obj = {
              proportion: Number(item.proportion) * 100,
              platServiceRate: 0,
              remark: '',
              divideChannel: item.proportion ? item.proportion : 1
            };
            this.isWechat ? obj.orgId = item.orgId : obj.acctNo = item.acctNo;
            subConfigs.push(obj);
          }
        });
        parameter.subConfigs = subConfigs;
        if (this.isWechat) {
          parameter.wxMchName = this.formValidate.wxMchName;
          parameter.wxMchId = this.formValidate.wxMchId.replace(/\s+/g, '');
        }
      }
      parameter.wxRate = Number((Number(this.formValidate.wxRate) * 100).toFixed(2));
      if (this.configId) {
        parameter.configId = this.configId;
        parameter.isEnable = this.formValidate.isEnable;
        parameter.smsCode = this.formValidate.smsCode;
        delete parameter.bankId;
        delete parameter.divideMode;
      }
      return parameter;
    },
    // 新增分账规则
    async saveDivideConfig() {
      const parameter = this.getParameter();
      if (!parameter) {
        return null;
      }
      this.isSaveing = true;
      this.$Spin.show();
      let res;

      res = await orderCenterApi.saveDivideConfig(parameter);
      this.$Spin.hide();
      this.isSaveing = false;
      if (res.status == 200) {
        this.$Message.success('新增规则成功');
        this.DELETE_CACHEROUTE('orderCenterProfitSharingIndex');
        this.handleGoBack();
      }
    },

    // 编辑 分账规则
    async updateDivideConfig() {
      const parameter = this.getParameter();
      if (!parameter) {
        return null;
      }

      this.$refs.smsCodeModal.handleOpen();
    },
    async updateDivideConfigHttp() {
      const parameter = this.getParameter();
      this.isSaveing = true;
      this.$Spin.show();
      let res;
      res = await orderCenterApi.updateDivideConfig(parameter);
      this.$Spin.hide();
      this.isSaveing = false;
      if (res.status == 200) {
        this.$Message.success('编辑规则成功');
        this.$refs.smsCodeModal.handleClose();
        this.handleGoBack();
      }
    },
    initDivideMode2() {
      this.divideMode2 = [{
        acctType: '比例分账',
        acctName: '课程提供方',
        proportion: 100,
        actionType: 1, // 1 : 显示，2:编辑
        accountType: 0,
        type: '1' // 1 : 主体、 2: 机构 3 末位  4 可选择课程提供方
      }];

      if (this.formValidate.divRuleAcctType == 1) {
        this.divideMode2.push({
          acctType: '末位分账',
          acctName: '末位分账',
          proportion: 0,
          accountType: 0,
          actionType: 1, // 1 : 显示，2:编辑
          type: '3' // 1 : 主体、 2: 机构 3 末位
        });
      }

      this.tableList = Object.assign([], this.divideMode2);
    },

    // 获取分账模式名称
    getModeName(code) {
      switch (Number(code)) {
        case 1:
          return '单方分账';
          break;
        case 2:
          return '多方分账';
          break;
      }
    },
    getAccountTypeName(val) {
      switch (Number(val)) {
        case 0:
          return '--';
          break;
        case 1:
          return '线上结算';
          break;
        case 2:
          return '线下结算';
          break;
      }
    },
    handleTableEdit(row, index) {
      this.tempInfo = {
        proportion: row.proportion,
        platServiceRate: row.platServiceRate,
        lastProportion: row.lastProportion
      };
      this.tableList[index].actionType = 2;
    },
    handleTableCancel(row, index) {
      this.tableList[index].platServiceRate = this.tempInfo.platServiceRate;
      this.tableList[index].proportion = this.tempInfo.proportion;
      this.tableList[index].actionType = 1;
      console.log(this.tableList);
    },
    // 删除
    handleTableDelete(row, index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '是否确认删除？',
        onOk: () => {
          this.divideMode2.splice(index, 1);
          this.tableList = Object.assign([], this.divideMode2);
        },
        onCancel: () => {

        }
      });
    },
    // 新增机构
    handleAdd() {
      this.replaceIndex = -1;
      this.isWechat ? this.$refs.chooseLineOrgModal.handleOpen() : this.$refs.chooseOneOrgModal.handleOpen();
    },
    // 替换机构
    handleTableReplace(row, index) {
      this.replaceIndex = index;
      this.isWechat ? this.$refs.chooseLineOrgModal.handleOpen(row.orgId) : this.$refs.chooseOneOrgModal.handleOpen(row.acctNo);
    },
    handleTableSave(row, index) {
      if (this.formValidate.divideMode == 1) {
        if (index == 0) {
          if (Number(this.tableList[index]['proportion']) > 100) {
            this.$Message.warning(`"分账基数" 不能大于 100%  `);
            return null;
          }
          if (Number(this.tableList[index]['platServiceRate']) < 0) {
            this.$Message.warning(`"分账基数" 不能小于 0%  `);
            return null;
          }
        } else {
          if (Number(this.tableList[index]['platServiceRate']) > 100) {
            this.$Message.warning(`"平台佣金" 不能大于 100%  `);
            return null;
          }

          if (Number(this.tableList[index]['platServiceRate']) < 0) {
            this.$Message.warning(`"平台佣金" 不能小于 0%  `);
            return null;
          }
        }
      }
      this.tableList[index].actionType = 1;
    },
    checkAllForm() {
      if (this.isSaveing) {
        return null;
      }
      if (this.configId) {
        this.updateDivideConfig();
      } else {
        this.saveDivideConfig();
      }
    },
    handleGoBack() {
      this.$router.push({
        name: 'orderCenter_profitSharing_index'
      });
    },
    // 选择机构
    onOrgFinish(data) {
      console.log('datadata', data);
      // 新增
      if (this.replaceIndex == -1) {
        const obj = {
          acctType: '比例分账',
          proportion: 0.00,
          actionType: 1, // 1 : 显示，2:编辑
          type: 2,
          accountType: this.isWechat ? 2 : 1
        };
        if (this.isWechat) {
          obj.acctName = data.name;
          obj.orgId = data.orgId;
        } else {
          obj.acctName = data.acctName;
          obj.acctNo = data.acctNo;
        }
        this.divideMode2.splice(this.divideMode2.length - 1, 0, obj);
        this.tableList = Object.assign([], this.divideMode2);
      } else {
        if (this.formValidate.divideMode == 1) {
          this.divideMode1[this.replaceIndex].acctName = data.acctName;
          this.divideMode1[this.replaceIndex].acctNo = data.acctNo;
          this.tableList = Object.assign([], this.divideMode1);
        } else {
          this.divideMode2[this.replaceIndex].acctName = this.isWechat ? data.name : data.acctName;
          this.isWechat ? this.divideMode2[this.replaceIndex].orgId = data.orgId : this.divideMode2[this.replaceIndex].acctNo = data.acctNo;
          this.tableList = Object.assign([], this.divideMode2);
        }
      }

      // console.log(data, this.divideMode2, this.tableList);
    },
    //
    hadnleSendCode(info) {
      this.formValidate.smsCode = info;
      this.updateDivideConfigHttp();
    },
    isDecimal(number) {
      var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      return reg.test(number);
    },
    // 业务分账类型 课程类型组件操作改变
    onCourseTypesChange(info) {
      if (info.typeIds.length != 0) {
        this.materialSingle = false;
      }
    },
    onMaterialSingleChange(val) {
      if (val) {
        this.$refs.courseTypesRef.handleClear();
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.edit {
  padding-bottom: 100px !important;
}

.cItem {
  margin-left: 30px;
}

.cwrap {
  display: flex;
  flex-direction: row;

  .dItem {
    display: flex;
    flex-direction: row;

    .dItem {
      display: flex;
      flex-direction: row;
      margin-right: 30px;
    }
  }
}
</style>
